<script>
import AdminNavbar from "@/components/AdminNavbar";
import AdminHeader from "@/components/AdminHeader";
import { useUiStore } from "../../stores/ui";
export default {
  setup() {
    const uiStore = useUiStore();
    const reduce = uiStore.reduce;
    return { reduce };
  },
  components: {
    AdminNavbar,
    AdminHeader,
  },
  computed: {
    isReduce() {
      return this.reduce;
    },
  },
};
</script>

<template>
  <div class="w-screen">
    <AdminNavbar class="fixed top-0 left-0 block z-10" />
    <div class="absolute top-0 left-0 min-h-full bg-gray-100 w-full block z-0"
      :class="{ 'pl-0 md:pl-72': !isReduce, 'pl-20': isReduce }">
      <AdminHeader class="py-5" />
      <div>
        <header class="bg-white py-8 pl-8">
          <span data-cy="adminHeader" class="text-2xl text-gray-600">{{
            $t(this.$route.name)
          }}</span>
        </header>
      </div>
      <div class="p-6">
        <router-view />
      </div>
    </div>
  </div>
</template>


<style scoped>
* {
  will-change: opacity, width, height, padding;
  transition: padding 300ms ease;
}
</style>
